import { Pipe, PipeTransform } from "@angular/core";
import { localization } from "@app2/shared/localization/localization";

@Pipe({ name: "localize" })
export class LocalizationPipe implements PipeTransform {
    transform(key: string, ...interpolations: any[]) {
        return localization.getString(key, ...interpolations);
    }
}
